import { gsap, ScrollTrigger } from "./globals.js";
import { animateChars } from './animate-chars.js';

document.addEventListener("DOMContentLoaded", () => {
	const latestNews = document.querySelector(".latest-news");
	if (!latestNews) return;

	document.querySelectorAll(".post-item-wrapper").forEach((post, i) => {
		const borderTop = post.querySelector(".post-border-top");
		const borderBottom = post.querySelector(".post-border-bottom");
		const meta = post.querySelector(".post-meta");
		const arrow = post.querySelector(".ui-arrow");

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: post,
				start: "top 80%",
				toggleActions: "play none none none",
				once: true
			}
		});

		tl.fromTo(borderTop, {
			scaleX: 0,
			transformOrigin: "left center"
		}, {
			scaleX: 1,
			duration: 1.2,
			ease: "power3.out"
		}, 0);

		tl.fromTo(borderBottom, {
			scaleX: 0,
			transformOrigin: "left center"
		}, {
			scaleX: 1,
			duration: 1.2,
			ease: "power3.out"
		}, 0);

		tl.add(animateChars(`.post-item-wrapper:nth-child(${i + 1}) .post-title`), 0);

		tl.fromTo([meta, arrow], {
			opacity: 0,
			y: 20
		}, {
			opacity: 1,
			y: 0,
			duration: 1.2,
			ease: "power2.out"
		}, 0);
	});
});
